import { populate } from "@/populate";
import {
  getCmsAuthorizationHeaderObject,
  getCmsUrl,
  getDeepBlocksFilter,
  getDeepTranslationsFilter,
  getImageField,
  serialize,
} from "@/services/cms";
import { httpClient } from "@/services/http";
import { LocaleCode } from "@/services/i18n";

import { getHomepageResponseSchema } from "./get-homepage.schema";
import type { GetHomepageRequestProps } from "./get-homepage.types";

export const GET_HOMEPAGE_ENDPOINT = "/items/homepage_new";

export const getHomepageRequest = async ({ locale }: GetHomepageRequestProps) => {
  const response = await httpClient
    .get(getCmsUrl(GET_HOMEPAGE_ENDPOINT), {
      headers: getCmsAuthorizationHeaderObject(),
      params: {
        deep: {
          ...getDeepBlocksFilter(LocaleCode.fromLocale(locale)),
          ...getDeepTranslationsFilter(LocaleCode.fromLocale(locale)),
        },
        fields: [
          "*",
          "translations.*",
          getImageField("translations.hero_image"),
          getImageField("translations.hero_image_medium"),
          getImageField("translations.experience_item_icon"),
          getImageField("translations.patients_item_icon"),
          getImageField("translations.bloodtests_item_icon"),
          getImageField("translations.opinion_item_icon"),
          ...populate.seo,
          ...populate.blocks,
          ...populate.promoBanner,
        ],
      },
      next: {
        tags: ["homepage_new", "blocks"],
        revalidate: false,
      },
      queryOptions: { arrayFormat: "comma" },
    })
    .then(serialize);

  return getHomepageResponseSchema.parse(response);
};
